import React, { useEffect, useState } from "react";
import { t } from "i18next";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import { FiUploadCloud } from "react-icons/fi";
//internal import
import { notifyError, notifySuccess } from "../../utils/toast";


const UploaderSlider = ({
  setImageUrl,
  imageUrl,
  is_multiple,
  no_of_image,
  folder,
  name_merge,
}) => {
  const [files, setFiles] = useState([]);
  const [, setLoading] = useState(false);
  const [, setError] = useState("");

  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    accept: "image/jpeg, image/jpg, image/png",
    multiple: is_multiple,
    maxSize: 70000,
    minSize: 40000,
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      const validFiles = [];
      const promises = acceptedFiles.map((file) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            const isValidDimensions =
              img.width >= 400 &&
              img.width <= 500 &&
              img.height >= 200 &&
              img.height <= 250;
            if (isValidDimensions) {
              validFiles.push(
                Object.assign(file, {
                  preview: URL.createObjectURL(file),
                })
              );
            } else {
              notifyError(
                "Image dimensions must be between 400-500px (width) and 200-250px (height)"
              );
            }
            resolve();
          };
          img.src = URL.createObjectURL(file);
        });
      });

      Promise.all(promises).then(() => {
        setFiles(validFiles);
      });
    },
  });

  useEffect(() => {
    if (fileRejections) {
      fileRejections.map(({ file, errors }) => (
        <li key={file.path}>
          {file.path} - {file.size} bytes
          <ul>
            {errors.map((e) => (
              <li key={e.code}>
                {e.code === "too-many-files"
                  ? notifyError(
                      `Maximum ${
                        no_of_image ? no_of_image : 2
                      } Image Can be Upload!`
                    )
                  : notifyError("File size must be less than 70kb")}
              </li>
            ))}
          </ul>
        </li>
      ));
    }

    if (files && files.length > 0) {
      const imageUrlCount = Array.isArray(imageUrl)
        ? imageUrl.length
        : imageUrl
        ? 1
        : 0;
      if (is_multiple === true && imageUrlCount + files?.length > no_of_image) {
        return notifyError(
          `Maximum ${no_of_image ? no_of_image : 2} Image Can be Upload!`
        );
      }

      setLoading(true);
      setError("Uploading....");
      const formData = new FormData();
      files.forEach((file, index) => {
        formData.append("file", file);
      });
      formData.append("folderName", folder);
      formData.append("name_merge", name_merge);

      axios({
        url: `${process.env.REACT_APP_API_BASE_URL}/upload/${
          files.length === 1 ? "upload-single" : "upload-multiple"
        }/${name_merge}/${folder}`,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      })
        .then((res) => {
          notifySuccess("Image Uploaded successfully!");
          setLoading(false);
          if (res && res.data.message !== "") {
            setImageUrl(res.data.image_path);
          }
        })
        .catch((err) => {
          console.error("err", err);
          notifyError(err.Message);
          setLoading(false);
        });
    }
            // eslint-disable-next-line 
  }, [files]);

  // const thumbs = files.map((file) => (
  //   <div key={file.name}>
  //     <div>
  //       <img
  //         className="inline-flex border-2 border-gray-100 w-24 max-h-24"
  //         src={file.preview}
  //         alt={file.name}
  //       />
  //     </div>
  //   </div>
  // ));

  useEffect(
    () => () => {
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files]
  );

  // const handleRemoveImage = async (img) => {
  //   const segments = img.split("/");
  //   const imageName = segments[segments.length - 1];
  //   const image_path = `${folder}/${imageName}`;
  //   axios({
  //     url: `${process.env.REACT_APP_API_BASE_URL}/upload/delete`,
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: { image_path },
  //   })
  //     .then((res) => {
  //       setLoading(false);
  //       notifyError(
  //         res.data.data === "ok" ? "Image deleted successfully!" : res.data.data
  //       );
  //       const result =
  //         (is_multiple === true && files.length > 1) ||
  //         (Array.isArray(imageUrl) && imageUrl.length > 1)
  //           ? imageUrl?.filter((i) => i !== image_path)
  //           : [];
  //       setImageUrl(result);
  //     })
  //     .catch((err) => {
  //       console.error("err", err);
  //       notifyError(err.Message);
  //       setLoading(false);
  //     });
  // };

  return (
    <div className="w-full text-center">
      <div
        className="border-2 border-gray-300 dark:border-gray-600 border-dashed rounded-md cursor-pointer px-6 pt-5 pb-6"
        {...getRootProps()}
      >
        <input {...getInputProps()} />
        <span className="mx-auto flex justify-center">
          <FiUploadCloud className="text-3xl text-green-500" />
        </span>
        <p className="text-sm mt-2">{t("DragYourImage")}</p>
        <em className="text-xs text-gray-400">{t("imageFormat")}</em>
      </div>

      {/* New section displaying image size limits */}
      <div className="mt-3 text-xs text-gray-500">
        <p>
          Image dimensions should be between 400-500px (width) and 200-250px
          (height) Min & Max file size: 40-70 KB.
        </p>
      </div>
    </div>
  );
};

export default UploaderSlider;
